import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Info, Luggage, Armchair } from 'lucide-react';
import { toBengaliNumeral } from '../utils/bengaliHelpers';
export function SegmentDetailsPage() {
  const navigate = useNavigate();
  return <div className="min-h-screen bg-gray-50 pb-24" data-id="element-392">
      <div className="bg-white sticky top-0 z-30 shadow-sm px-4 py-4 flex items-center space-x-3" data-id="element-393">
        <button onClick={() => navigate(-1)} className="p-2 hover:bg-gray-100 rounded-full" data-id="element-394">
          <ArrowLeft size={24} data-id="element-395" />
        </button>
        <h1 className="font-bold font-bengali text-lg" data-id="element-396">লঞ্চের বিস্তারিত</h1>
      </div>

      <div className="p-4 space-y-6" data-id="element-397">
        {/* Ship Info */}
        <div className="bg-white p-5 rounded-2xl border border-gray-200 shadow-sm" data-id="element-398">
          <div className="flex justify-between items-start mb-4" data-id="element-399">
            <div data-id="element-400">
              <h2 className="text-xl font-bold font-bengali text-gray-900" data-id="element-401">
                এম ভি কর্ণফুলী ১০
              </h2>
              <p className="text-gray-500 font-bengali" data-id="element-402">ঢাকা (সদরঘাট) ➝ ভোলা</p>
            </div>
            <div className="bg-green-100 text-green-700 px-3 py-1 rounded-full text-xs font-bold font-bengali" data-id="element-403">
              এভেইলেবল
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4 mb-4" data-id="element-404">
            <div className="bg-gray-50 p-3 rounded-xl" data-id="element-405">
              <p className="text-xs text-gray-500 font-bengali" data-id="element-406">ছাড়ার সময়</p>
              <p className="text-lg font-bold text-gray-900 font-bengali" data-id="element-407">
                ০৮:০০ সকাল
              </p>
            </div>
            <div className="bg-gray-50 p-3 rounded-xl" data-id="element-408">
              <p className="text-xs text-gray-500 font-bengali" data-id="element-409">
                পৌঁছানোর সময়
              </p>
              <p className="text-lg font-bold text-gray-900 font-bengali" data-id="element-410">
                ১২:৩০ দুপুর
              </p>
            </div>
          </div>

          <div className="space-y-3" data-id="element-411">
            <div className="flex items-center text-gray-600" data-id="element-412">
              <Luggage size={18} className="mr-3" data-id="element-413" />
              <span className="font-bengali text-sm" data-id="element-414">২০ কেজি লাগেজ ফ্রি</span>
            </div>
            <div className="flex items-center text-gray-600" data-id="element-415">
              <Info size={18} className="mr-3" data-id="element-416" />
              <span className="font-bengali text-sm" data-id="element-417">
                রিপোর্টিং টাইম: ৩০ মিনিট আগে
              </span>
            </div>
          </div>
        </div>

        {/* Seat Selection */}
        <div className="space-y-3" data-id="element-418">
          <h3 className="font-bold text-gray-900 font-bengali text-lg" data-id="element-419">
            সিট ক্লাস নির্বাচন করুন
          </h3>

          {[{
          name: 'ডেক (সাধারণ)',
          price: 350,
          seats: 'পর্যাপ্ত সিট'
        }, {
          name: 'সিঙ্গেল কেবিন (নন-এসি)',
          price: 1200,
          seats: '৫টি বাকি'
        }, {
          name: 'ভিআইপি কেবিন (এসি)',
          price: 2500,
          seats: '২টি বাকি'
        }].map((cls, idx) => <div key={idx} className="bg-white p-4 rounded-xl border border-gray-200 flex justify-between items-center" data-id="element-420">
              <div className="flex items-center space-x-3" data-id="element-421">
                <div className="bg-[#006a4e]/10 p-2 rounded-lg text-[#006a4e]" data-id="element-422">
                  <Armchair size={20} data-id="element-423" />
                </div>
                <div data-id="element-424">
                  <p className="font-bold font-bengali text-gray-900" data-id="element-425">
                    {cls.name}
                  </p>
                  <p className="text-xs text-orange-600 font-bengali" data-id="element-426">
                    {cls.seats}
                  </p>
                </div>
              </div>
              <div className="text-right" data-id="element-427">
                <p className="font-bold text-[#006a4e] font-bengali text-lg" data-id="element-428">
                  ৳{toBengaliNumeral(cls.price)}
                </p>
                <button onClick={() => navigate('/passenger-info')} className="mt-1 px-4 py-1.5 bg-[#006a4e] text-white text-sm font-bold rounded-lg font-bengali" data-id="element-429">
                  বাছাই
                </button>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}